export const INITIAL_FETCH = 'initial';
export const REQUESTING_FETCH = 'requesting';
export const SUCCESS_FETCH = 'success';
export const FAILURE_FETCH = 'failure';
